import { el, mount, unmount } from 'redom';

import serverInterface from 'server-interface';
import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import { isPropertyValueExists } from 'utilities/collection';

import modes from './modes';
import EventDisplay from './display';
import EventRegistrations from './registrations';

import styleAsString from './styles/index.scss?inline';

class HTStartupEvent extends HTMLElement {

  constructor() {

    super();

    this.attachShadow({ mode: 'open' });

    this.postId = null;
    this.event = null;
    this.currentUser = null;
    this.main = null;
    this.authenticated = application.isAuthenticated();

    mount(this.shadowRoot, this.getStyleEl());

  }

  connectedCallback() {

    const postIdAttributeName = 'postId';

    this.postId = this.getAttribute(postIdAttributeName);

    this.currentUser = application.getUser();

    this.loadEvent();

  }

  disconnectedCallback() {

    this.tryUnmountEventAndRegistrationsDisplay();

  }

  displaySpinner() {

    const spinner = el('ht-spinner');

    mount(this.shadowRoot, spinner);

    return spinner;

  }

  hideSpinner(spinner) {

    unmount(this.shadowRoot, spinner);

  }

  async loadEvent() {

    const spinner = this.displaySpinner();

    const event = await serverInterface.startup.community.events.getEventByPostId(this.postId);

    const registrations = await serverInterface.startup.community.events.getEventRegistrationsByPostId(this.postId);

    this.debugButton = el('button', 'Goto live stream');
    this.debugButton.addEventListener('click', function handleClick() {
      application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
        to: `/community/${event.postId}/live`
      });

    });

    this.hideSpinner(spinner);

    this.mountEventAndRegistrationsDisplay(event, registrations);

  }

  getStyleEl() {

    const styleCode = `

      ${styleAsString}

     `;

    const style = el('style', styleCode);

    return style;

  }

  remount() {

    this.unmountAll();
    this.mountAll();

  }

  isOwner() {

    if (this.authenticated === false) {
      return false;
    }

    if (this.event.ownerId !== this.currentUser._id) {
      return false;
    }

    return true;

  }

  getDisplayMode() {

    if (application.isAuthenticated() === false) {
      return modes.READ;
    }

    return modes.WRITE;

  }

  isCurrentUserAlreadyRegistered(registrations, mode) {

    if (mode === modes.READ) {
      return false;
    }

    return isPropertyValueExists(registrations, 'userId', application.getUser()._id);

  }

  initializeEventDisplay(event, registrations) {

    const mode = this.getDisplayMode();
    const alreadyRegistered = this.isCurrentUserAlreadyRegistered(registrations, mode);

    this.eventDisplay = new EventDisplay(event, mode, alreadyRegistered);

  }

  initializeEventRegistrations(event, registrations) {

    this.eventRegistrations = new EventRegistrations(event, registrations);
    this.eventRegistrations.initialize();

  }

  mountEventAndRegistrationsDisplay(event, registrations) {

    const shadowRoot = this.shadowRoot;

    this.initializeEventDisplay(event, registrations);
    this.initializeEventRegistrations(event, registrations);

    this.main = el('div.ht-startup-event-main', [this.eventDisplay, this.eventRegistrations]);

    mount(shadowRoot, this.main);

  }

  unmountEventAndRegistrationsDisplay() {

    const main = this.main;

    unmount(main, this.eventDisplay);
    unmount(main, this.eventRegistrations);

  }

  tryUnmountEventAndRegistrationsDisplay() {

    if (this.main === null) {
      return;
    }

    this.unmountEventAndRegistrationsDisplay();

  }

};

export default HTStartupEvent;